import api from "@/services/api";

const _http = {
  // ───────── BY DOCUMENT_ID (mode edit/detail) ─────────
  getChecklist(documentId) {
    return api.get(`/monitoring-document/${documentId}/checklist`);
  },

  uploadChecklistFile(documentId, key, file) {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(
      `/monitoring-document/${documentId}/checklist/${key}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  },

  deleteChecklistFile(documentId, key) {
    return api.delete(`/monitoring-document/${documentId}/checklist/${key}`);
  },

  // ───────── BY CORPORATE_ID (mode add) ─────────
  getChecklistByCorporate(corporateId) {
    return api.get(`/legal-document/checklist/corporate/${corporateId}`);
  },

  uploadChecklistFileByCorporate(corporateId, key, file) {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(
      `/legal-document/checklist/corporate/${corporateId}/${key}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  },

  deleteChecklistFileByCorporate(corporateId, key) {
    return api.delete(
      `/legal-document/checklist/corporate/${corporateId}/${key}`,
    );
  },
};

export default {
  // ───────── BY DOCUMENT_ID (mode edit/detail) ─────────
  async getChecklist(documentId) {
    try {
      const res = await _http.getChecklist(documentId);
      return res.data.data;
    } catch (error) {
      console.error("Error getting checklist:", error);
      return { company_type: "PT", items: [], is_complete: false, missing: [] };
    }
  },

  async uploadFile(documentId, key, file) {
    return await _http.uploadChecklistFile(documentId, key, file);
  },

  async deleteFile(documentId, key) {
    return await _http.deleteChecklistFile(documentId, key);
  },

  // ───────── BY CORPORATE_ID (mode add) ─────────
  async getChecklistByCorporate(corporateId) {
    try {
      const res = await _http.getChecklistByCorporate(corporateId);
      return res.data.data;
    } catch (error) {
      console.error("Error getting checklist by corporate:", error);
      return { company_type: "PT", items: [], is_complete: false, missing: [] };
    }
  },

  async uploadFileByCorporate(corporateId, key, file) {
    return await _http.uploadChecklistFileByCorporate(corporateId, key, file);
  },

  async deleteFileByCorporate(corporateId, key) {
    return await _http.deleteChecklistFileByCorporate(corporateId, key);
  },
};
